import * as React from 'react';

const LogoYahooSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.3 19.5c-.8-.1-1.3.2-1.5 1-.2.8.4 1.4.9 1.5.6.1 1.4 0 1.6-.8.3-.8-.2-1.5-1-1.7zM17.7 2s-.6.2-1.4.2C15.5 2.2 15 2 15 2l-5.2 8.8L4.5 2s-.5.2-1.3.2S1.8 2 1.8 2l6.8 11.5-.1 8.5s.6-.2 1.4-.2c.8 0 1.3.2 1.3.2l-.2-8.5L17.7 2zm3.3.2c-.6-.1-1.4.1-1.5 1.4-.1 1.3-1.4 14-1.4 14h.5c.2 0 .4.2.4.2S21.8 5 22.1 3.9c.3-1.2-.5-1.6-1.1-1.7z"
        />
    </svg>
);

LogoYahooSvg.displayName = 'LogoYahooSvg';
export default LogoYahooSvg;
